// ###### IMPORTS
import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import NoteCard from '../../tab_notes/viewComponents/note_card';

// ###### COMPONENT
const ClusterSection = ({ 
  cluster, 
  notes, 
  isCollapsed, 
  onToggleCollapse, 
  onNoteClick,
  viewMode 
}) => {
  const clusterColor = cluster?.color || null;
  const clusterName = cluster?.name || 'No cluster';
  const notesCount = notes.length;

  return (
    <div>
      {/* Header Section */}
      <button
        onClick={onToggleCollapse}
        className="w-full flex items-center justify-between gap-3 pb-2 mb-2 border-b border-gray-300 hover:bg-gray-50 -mx-2 px-2 py-1 rounded transition-colors text-left select-none"
        aria-label={isCollapsed ? 'Expand' : 'Collapse'}
      >
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {/* Color Circle or No Cluster Icon */}
          {clusterColor ? (
            <div 
              className="w-6 h-6 rounded-full flex-shrink-0"
              style={{ backgroundColor: clusterColor }}
            />
          ) : (
            <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
              <NoSymbolIcon className="w-6 h-6 text-gray-400" strokeWidth={2} />
            </div>
          )}
          
          {/* Cluster Name */}
          <h3 className="text-lg font-semibold text-gray-800 truncate">
            {clusterName}
          </h3>
          
          {/* Notes Count */}
          <span className="text-sm text-gray-500 whitespace-nowrap">
            ({notesCount})
          </span>
        </div>
        
        {/* Chevron Icon */}
        <ChevronDownIcon 
          className={`h-5 w-5 text-gray-500 transition-transform flex-shrink-0 ${isCollapsed ? '' : 'rotate-180'}`}
        />
      </button>

      {/* Notes Grid */}
      {!isCollapsed && (
        <div className="pl-2">
          {notesCount === 0 ? (
            <div className="text-sm text-gray-400 italic py-4">
              No notes in this cluster
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              {notes.map((note) => (
                <NoteCard
                  key={note.id}
                  note={note}
                  onClick={() => onNoteClick(note)}
                  viewMode={viewMode}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClusterSection;
